import { TransportView } from './transport-view.model';
import dayjs from 'dayjs';
import { ColorEnum } from './enums/color.enum';
import { QuotationStatusEnum } from './enums/quotation-status.enum';

export class QuotationView extends TransportView {
  public collapsed?: boolean;

  constructor(data: any = {}) {
    super(data);
    this.collapsed = data.collapsed;
    this.quotationValidityDate = data.quotationValidityDate ? dayjs(data.quotationValidityDate) : dayjs(Date.now());
  }

  public quotationStatusBadgeOpts(isModerator: boolean = false): {
    labelKey?: string;
    color: ColorEnum;
    icon?: string;
    tooltipKey?: string;
    iconTooltipKey?: string;
    iconTooltipParams?: any;
  } {
    const status: QuotationStatusEnum = this.quotationStatus!;
    const labelKey = `baryApp.quotationStatus.${isModerator ? 'moderator.' : 'customer.'}${status}`;

    const dangerStatuses = [QuotationStatusEnum.TRANSPORTER_REJECTED, QuotationStatusEnum.CUSTOMER_REJECTED];
    const warningStatuses = [
      QuotationStatusEnum.CUSTOMER_ACCEPTED_BUT_EXPIRED_PICKUP_DATE,
      QuotationStatusEnum.CUSTOMER_ACCEPTED_BUT_EXPIRED_VALIDITY_DATE,
      QuotationStatusEnum.TRANSPORTER_EXPIRED_PICKUP_DATE,
      QuotationStatusEnum.CUSTOMER_EXPIRED_PICKUP_DATE,
      QuotationStatusEnum.CUSTOMER_EXPIRED_VALIDITY_DATE,
    ];
    const infoStatuses = [QuotationStatusEnum.NEW, QuotationStatusEnum.TRANSPORTER_ACCEPTED];
    const successStatuses = [QuotationStatusEnum.CUSTOMER_ACCEPTED, QuotationStatusEnum.FINALIZED];

    if (dangerStatuses.includes(status)) {
      return {
        labelKey,
        color: ColorEnum.DANGER,
        icon: this.quotationRejectionMessage ? 'info-circle' : undefined,
        iconTooltipKey: this.quotationRejectionMessage ? 'baryApp.quotationStatus.cause' : undefined,
        iconTooltipParams: { cause: this.quotationRejectionMessage },
      };
    }

    if (warningStatuses.includes(status)) {
      return { labelKey, color: ColorEnum.WARNING };
    }

    if (successStatuses.includes(status)) {
      return { labelKey, color: ColorEnum.SUCCESS };
    }

    if (infoStatuses.includes(status)) {
      return { labelKey, color: ColorEnum.INFO };
    }
    return { labelKey, color: ColorEnum.INFO };
  }
}
